// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"58e8accf","330":"b811a841","515":"800f1287","558":"126c38a5","719":"7b2498ed","795":"0c311d74","901":"f1675076"}[chunkId] + ".chunk.css";
};